// src/utils/populateCSSVariables.ts
var populateCSSVariables = (colorScheme, prefix) => {
  const result = {};
  const processObject = (obj, path = []) => {
    Object.entries(obj).forEach(([key, value]) => {
      if (typeof value === "string") {
        const varName = `--${prefix}-${[...path, key].join("-")}`;
        result[varName] = value;
      } else if (typeof value === "object") {
        processObject(value, [...path, key]);
      }
    });
  };
  processObject(colorScheme);
  return result;
};

export {
  populateCSSVariables
};
